export const moreGameConfigByLocale = (locale: string) => {
  return {
    title: 'Home.MoreGames.Title',
    subtitle: 'Home.MoreGames.Subtitle',
  };
};
